<template>
    <index-table
        :cols="[
            {
                value: 'name',
                label: 'Name',
                sortable: true,
                searchable: true,
            },
            {
                value: 'title',
                label: 'Title',
                sortable: true,
                searchable: true,
            },
            {
                value: 'email',
                label: 'Email',
                sortable: true,
                searchable: true,
            },
            {
                value: 'username',
                label: 'Username',
                sortable: true,
                searchable: true,
            },
            {
                value: 'with_premium_mobile_features',
                label: 'Features',
                sortable: false,
                searchable: true,
                display: 'name',
            },
            {
                value: 'confirmed',
                label: 'Confirmed',
                sortable: true,
                searchable: true,
                customCell: 'UsersConfirmedCell',
            },
        ]"
        :title="'Premium Users'"
        :model="'users/premium'"
    />
</template>

<script>
import IndexTable from '@/components/IndexTable/index.vue'

export default {
    components: {
        IndexTable,
    },
}
</script>
